export const getFileExtension = (fileName?: string): string | undefined => {
  const fileNameParts = fileName?.split('.');

  if (!fileNameParts || fileNameParts.length < 2) {
    return '';
  }

  return fileNameParts.pop();
};
